import {Component, createRef} from "preact";
import styles from './styles.scss';

export default class ScrollableSection extends Component {

    constructor(props) {
        super(props);

        this.state = {
            area: null
        };
    }

    componentDidUpdate = () => {
        if (this.state.area === null) {
            this.onScroll();
        }
    };

    static defaultProps = {
        scrollTreshold: 50,
        onAreaChange: () => {}
    };

    ref = createRef();

    render(props, state, context) {
        const classes = [styles.scrollableContainer, props.class].filter(i => i).join(' ');

        return (
            <div class={classes} ref={this.ref} style={props.style} onScroll={this.onScroll}>
                {props.children}
            </div>
        );
    }

    onScroll = () => {
        const area = this.calcArea();
        if(area !== this.state.area) {
            this.setState({area});
            this.props.onAreaChange(area);
        }
    };

    calcArea = () => {
        const el = this.ref.current;
        const maxScroll = el.scrollHeight - el.offsetHeight;
        const scrollPos = el.scrollTop;

        if (scrollPos === 0) return 'top';
        else if (scrollPos === maxScroll) return 'bottom';
        else if (scrollPos < this.props.scrollTreshold) return('top');
        else if (scrollPos > maxScroll - this.props.scrollTreshold) return('bottom');
        else return('middle');
    };

    scrollBottom () {
        const el = this.ref.current;
        return el.scrollHeight - el.scrollTop;
    }

    scrollFromBottom(value) {
        const el = this.ref.current;
        el.scrollTop = el.scrollHeight - value;
    }
}



// WEBPACK FOOTER //
// ./components/layout/scrollable-section/index.js